import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { noop } from '~/core/scripts/utils';

const SearchPresetsWrapper = styled.div`
  display: flex;
  margin-top: 5px;
`;

const Label = styled.div`
  margin-right: 5px;
`;

const List = styled.div`
  display: flex;
`;

const Item = styled.div`
  cursor: pointer;
  font-weight: 700;
  margin-right: 5px;

  &:hover {
    opacity: 0.8;
  }
`;

const SearchPresets = memo(({ presets, title, onClick = noop }) => {
  if (!presets || presets.length === 0) {
    return null;
  }

  return (
    <SearchPresetsWrapper>
      {title && <Label>{title}</Label>}
      <List>
        {presets.map((p) => (
          <Item key={`search__preset_${p.name}`} onClick={() => onClick(p)}>
            {p.name}
          </Item>
        ))}
      </List>
    </SearchPresetsWrapper>
  );
});

SearchPresets.displayName = 'SearchPresets';

SearchPresets.propTypes = {
  title: PropTypes.string,
  presets: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
    })
  ),
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default SearchPresets;
